import { useState } from 'react';
import { Group, KhachHang, KhuVuc, TaiKhoan, VatTu } from '@/types/schemas';

/**
 * Hook for managing search field states in the bao-cao-tong-hop-ban-hang-thuan feature
 *
 * @returns Object with states and setters for search fields
 */
export const useSearchFieldStates = () => {
  // DetailsTab SearchFields
  const [customer, setCustomer] = useState<KhachHang | null>(null);
  const [customerGroup1, setCustomerGroup1] = useState<Group | null>(null);
  const [customerGroup2, setCustomerGroup2] = useState<Group | null>(null);
  const [customerGroup3, setCustomerGroup3] = useState<Group | null>(null);
  const [region, setRegion] = useState<KhuVuc | null>(null);
  const [vatTu, setVatTu] = useState<VatTu | null>(null);
  const [vatTuGroup1, setVatTuGroup1] = useState<Group | null>(null);
  const [vatTuGroup2, setVatTuGroup2] = useState<Group | null>(null);
  const [vatTuGroup3, setVatTuGroup3] = useState<Group | null>(null);

  // OtherTab SearchFields
  const [transaction, setTransaction] = useState<BanHangRecord | null>(null);
  const [accountVatTu, setAccountVatTu] = useState<TaiKhoan | null>(null);
  const [accountDoanhThu, setAccountDoanhThu] = useState<TaiKhoan | null>(null);
  const [accountGiaVon, setAccountGiaVon] = useState<TaiKhoan | null>(null);
  const [lot, setLot] = useState<BanHangRecord | null>(null);
  const [location, setLocation] = useState<BanHangRecord | null>(null);

  return {
    // DetailsTab SearchFields
    customer,
    setCustomer,
    customerGroup1,
    setCustomerGroup1,
    customerGroup2,
    setCustomerGroup2,
    customerGroup3,
    setCustomerGroup3,
    region,
    setRegion,
    vatTu,
    setVatTu,
    vatTuGroup1,
    setVatTuGroup1,
    vatTuGroup2,
    setVatTuGroup2,
    vatTuGroup3,
    setVatTuGroup3,

    // OtherTab SearchFields
    transaction,
    setTransaction,
    accountVatTu,
    setAccountVatTu,
    accountDoanhThu,
    setAccountDoanhThu,
    accountGiaVon,
    setAccountGiaVon,
    lot,
    setLot,
    location,
    setLocation
  };
};
